import { rnd2 } from "../../../Game";
import { Node } from "../../../Utils/Collections/Node";
import { NodeList } from "../../../Utils/Collections/NodeList";
import { DecoType as DecoType } from "./DecoType";



class EntityPool {
    /**
     * Typ entity
     */
    private _entType: DecoType;
    /**
     * Index snimku, ktery pouzivaji entity v tomto poolu
     */
    private _frameId: number;
    /**
     * Zbyvajici pocet nevyuzitych entit
     */
    private _freeEntCnt: number;
    /**
     * (RO) True, pokud je pool prazdny
     */
    get isEmpty(): boolean { return this._freeEntCnt == 0; }

    private static _frameWrapper: DecoEntityPackage = { entity: null, positon: null }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(decoType: DecoType, frameId: number) {
        this._entType = decoType;
        this._frameId = frameId;
        this._freeEntCnt = this._entType.frameEnts[frameId].entities.length;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getEntity(): DecoEntityPackage {
        let wrapper = EntityPool._frameWrapper;

        this._freeEntCnt--;

        wrapper.entity = this._entType.frameEnts[this._frameId].entities[this._freeEntCnt];
        wrapper.positon = this._entType.frameEntPositions[this._frameId][this._freeEntCnt];

        return wrapper;
    }
}



/**
 * Balicek zapouzdrujici entitu a jeji pozici
 */
export interface DecoEntityPackage {
    entity: pc.Entity;
    positon: pc.Vec3;
}



/**
 * Nahodny vyber entit s konkretni grafikou + pc.Vec3 s jeji pozici
 */
export class DecoEntityProvider {
    /**
     * Pooly s entitami pro jednotlive typy
     */
    private _pools: EntityPool[][];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(decoType: NodeList<DecoType>) {
        this._pools = [];

        decoType.forEach((type: DecoType): void => {
            let frameCnt = type.frameEntPositions.length;
            let pools: EntityPool[] = [];

            for (let frameId = 0; frameId < frameCnt; frameId++)
                pools.push(new EntityPool(type, frameId));

            this._pools.push(pools);
        });
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci balicek s nahodne vybranou entitou
     * @returns 
     */
    //-------------------------------------------------------------------------
    getEntity(decoTypeId: number): DecoEntityPackage {
        let typePools = this._pools[decoTypeId];
        let poolId = rnd2.randomIntIn(0, typePools.length - 1);
        let pool = typePools[poolId];
        let ent = pool.getEntity();

        if (pool.isEmpty) {
            // Odstranit pool ze seznamu
            if (typePools.length > 1) {
                typePools.splice(poolId, 1);
            }
            else {
                this._pools[decoTypeId].length = 0;
            }
        }

        return ent;
    }
}
